module.exports = "/_next/static/images/interview-mock-device-9fea0711d7369aeb695c225f26ec9431.png";